import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import { CustomerType } from '@model/customer';

export const selectAppState = createFeatureSelector<fromApp.State>(
  fromApp.appFeatureKey
);

export const selectAllSources = createSelector(selectAppState, state => state.sources);
export const selectRestaurantId = createSelector(selectAppState, state => state.restaurantId);
export const selectRestaurantName = createSelector(selectAppState, state => state.restaurantName);
export const selectIsOffline = createSelector(selectAppState, state => state.isOffline);
export const selectQueueHttpRequests = createSelector(selectAppState, state => state.queueHttpRequests);
export const selectAlert = createSelector(selectAppState, state => state.alert);
export const selectMenus = createSelector(selectAppState, state => state.menus);
export const selectOnlineCategories = createSelector(selectAppState, state => state.onlineCategories);
export const selectVisibleOnlineCategories = createSelector(selectAppState, state =>
  ([...(state.onlineCategories ?? [])])
    .filter(category => !category.hidden && category.name !== '—')
    .sort((a, b) => {

      const aOrder = a.displayOrder ?? 0;
      const bOrder = b.displayOrder ?? 0;

      if (aOrder > bOrder) {
        return 1;
      }

      if (aOrder < bOrder) {
        return -1;
      }

      return 0;
    })
);
export const selectCustomerTypes = createSelector(selectAppState, state =>
  ([...(state.customerTypes ?? [])]).sort((customerTypeA: CustomerType, customerTypeB: CustomerType) => {

    let orderA = customerTypeA.order != null ? parseInt(customerTypeA.order) : null;
    let orderB = customerTypeB.order != null ? parseInt(customerTypeB.order) : null;

    if ((orderA == null || isNaN(orderA)) && orderB != null && !isNaN(orderB)) {
      return -1;
    }

    if (orderA != null && !isNaN(orderA) && (orderB == null || isNaN(orderB))) {
      return 1;
    }

    orderA = orderA as number;
    orderB = orderB as number;

    if (orderA > orderB) {
      return 1;
    }

    if (orderA < orderB) {
      return -1;
    }

    return 0;
  })
);
export const selectRestaurantHasOnlineCategories = createSelector(selectAppState, state => state.onlineCategories != null
  && state.onlineCategories.length > 0
  && state.onlineCategories.some(category => category.name !== '—'));
export const selectRestaurantHasExtraInfo = createSelector(selectAppState, state => state.menus != null && state.menus.length > 0);
export const selectTags = createSelector(selectAppState, state => state.tags);
export const selectCommunication = createSelector(selectAppState, state => state.communication);
export const selectServiceStopDate = createSelector(selectAppState, state => state.serviceStopDate);
export const selectRestaurantHasCommunication = createSelector(selectAppState, state => state.communication != null && state.communication.valid === true);
export const selectRestaurantHasSmsCommunication = createSelector(selectAppState, state => state.communication != null &&
  state.communication.communicationChannels != null &&
  state.communication.communicationChannels.some(x => x.value == "SMS") === true);
export const selectRestaurantHasEmailCommunication = createSelector(selectAppState, state => state.communication != null &&
  state.communication.communicationChannels != null &&
  state.communication.communicationChannels.some(x => x.value == "EMAIL") === true);
export const selectExtraStatuses = createSelector(selectAppState, state => state.extraStatuses);
export const selectMinTelephoneLength = createSelector(selectAppState, state => state.minTelephoneLength);
export const selectAdvertisment = createSelector(selectAppState, state => state.ads);
export const selectAppSettings = createSelector(selectAppState, state => state.appSettings);
export const selectEditingAppSettings = createSelector(selectAppState, state => state.editingAppSettings);
export const selectReservationListFontSize = createSelector(selectAppState, state => state.appSettings.fontSize.reservationList);
export const selectReservationFormFontSize = createSelector(selectAppState, state => state.appSettings.fontSize.reservationForm);
export const selectTablesPlanFontSize = createSelector(selectAppState, state => state.appSettings.fontSize.tablesPlan);
export const selectToast = createSelector(selectAppState, state => state.toast);
export const selectRestaurants = createSelector(selectAppState, state => state.restaurants);


